import { DirectLinkingState } from '@acorns/web-bank-linking'
import toSnakeCase from 'to-snake-case'

const formatName = (name: string) => `${toSnakeCase(name)}_`

const SCREEN_VIEWED_EVENTS = {
  [DirectLinkingState.success]: (name: string) => ({
    screen_name: `${formatName(name)}oAuthFlowSuccess`,
    screen: `${formatName(name)}oAuthFlowSuccess`,
    object_name: `${formatName(name)}LinkedSuccessful`,
  }),
  [DirectLinkingState.ready]: (name: string) => ({
    screen_name: `${formatName(name)}Interstitial`,
    screen: `${formatName(name)}Interstitial`,
    object_name: `${formatName(name)}Interstitial`,
  }),
  [DirectLinkingState.error]: (name: string) => ({
    screen_name: `${formatName(name)}oAuthFlowError`,
    screen: `${formatName(name)}oAuthFlowError`,
    object_name: `${formatName(name)}LinkingError`,
  }),
  [DirectLinkingState.checkingUnavailable]: (name: string) => ({
    screen_name: `${formatName(name)}oAuthNeedsChecking`,
    screen: `${formatName(name)}oAuthNeedsChecking`,
    object_name: `${formatName(name)}oAuthNeedsChecking`,
  }),
  [DirectLinkingState.accountAndRoutingNumbersUnavailable]: (name: string) => ({
    screen_name: `${formatName(name)}oAuthFlowNoRouting`,
    screen: `${formatName(name)}oAuthFlowNoRouting`,
    object_name: `${formatName(name)}oAuthNoRouting`,
  }),
}

export enum ButtonCtaType {
  start = 'start',
  tryAgain = 'tryAgain',
  manualLink = 'manualLink',
}

const BUTTON_TAPPED_EVENTS = {
  [DirectLinkingState.ready]: {
    [ButtonCtaType.start]: (name: string) => ({
      cta_title: 'Next',
      object_name: `${formatName(name)}InterstitialNextCTA`,
      screen_name: `${formatName(name)}Interstitial`,
      screen: `${formatName(name)}Interstitial`,
    }),
  },
  [DirectLinkingState.error]: {
    [ButtonCtaType.tryAgain]: (name: string) => ({
      cta_title: 'Try again',
      screen_name: `${formatName(name)}oAuthFlowError`,
      screen: `${formatName(name)}oAuthFlowError`,
      object_name: `${formatName(name)}LinkingErrorTryAgainCTA`,
    }),
  },
  [DirectLinkingState.checkingUnavailable]: {
    [ButtonCtaType.tryAgain]: (name: string) => ({
      cta_title: 'Link another account',
      screen_name: `${formatName(name)}oAuthNeedsChecking`,
      screen: `${formatName(name)}oAuthNeedsChecking`,
      object_name: 'LinkAnotherAccountCTA',
    }),
    [ButtonCtaType.manualLink]: (name: string) => ({
      cta_title: 'Use routing & account number instead',
      screen_name: `${formatName(name)}oAuthNeedsChecking`,
      screen: `${formatName(name)}oAuthNeedsChecking`,
      object_name: 'LinkManuallyCTA',
    }),
  },
  [DirectLinkingState.accountAndRoutingNumbersUnavailable]: {
    [ButtonCtaType.tryAgain]: (name: string) => ({
      cta_title: 'Link a different account instead',
      screen_name: `${formatName(name)}oAuthFlowNoRouting`,
      screen: `${formatName(name)}oAuthFlowNoRouting`,
      object_name: 'LinkDifferentAccountCTA',
    }),
    [ButtonCtaType.manualLink]: (name: string) => ({
      cta_title: 'Next',
      screen_name: `${formatName(name)}oAuthFlowNoRouting`,
      screen: `${formatName(name)}oAuthFlowNoRouting`,
      object_name: 'AuthNoRoutingNextCTA',
    }),
  },
}

export const resolveLinkingScreenViewedEvent = (linkingState: DirectLinkingState, name: string) => {
  return SCREEN_VIEWED_EVENTS[linkingState]?.(name)
}

export const resolveLinkingButtonTappedEvent = (
  linkingState: DirectLinkingState,
  buttonCtaType: ButtonCtaType,
  name: string,
) => {
  return BUTTON_TAPPED_EVENTS[linkingState]?.[buttonCtaType]?.(name)
}

export const resolveSuccessButtonTappedEvent = (name: string) => ({
  object_name: 'SuccessNextCTA',
  screen_name: `${formatName(name)}oAuthFlowSuccess`,
  screen: `${formatName(name)}oAuthFlowSuccess`,
})

export const resolveChooseFundingViewedEvent = (name: string) => ({
  screen: `${formatName(name)}oAuthPrimarySelection`,
  screen_name: `${formatName(name)}oAuthPrimarySelection`,
  object_name: `${formatName(name)}oAuthPrimarySelection`,
})

export const resolveChooseFundingButtonTappedEvent = (name: string) => ({
  screen: `${formatName(name)}oAuthPrimarySelection`,
  screen_name: `${formatName(name)}oAuthPrimarySelection`,
  object_name: `${formatName(name)}oAuthPrimaryNextCTA`,
})
